import React from "react";
import { Stack, TextField, Typography } from "@mui/material";
import { usePickUserPermissions, useUserRoleSelector } from "store";
import { isRoleAnalyst } from "utils/user";
import { UserPermissionType } from "store/types";

interface Props {
  inputValue: string;
  setInputValue: React.Dispatch<React.SetStateAction<string>>;
  errorMessage: string;
}

export const Connect: React.FC<Props> = ({ inputValue, setInputValue, errorMessage }) => {
  const role = useUserRoleSelector();
  const myDeals = usePickUserPermissions("deals");
  const noAccessPermission = myDeals && myDeals === UserPermissionType.NO_ACCESS;
  const isViewerPermission = myDeals && myDeals === UserPermissionType.VIEWER;
  return (
    <Stack gap="22px">
      <Typography color="#0A3142" fontSize="16px">
        Connect to the Crunchbase by adding the URL of the company page from the Crunchbase website.
      </Typography>
      <TextField
        sx={{
          ".MuiOutlinedInput-notchedOutline": {
            borderColor: "#5d7782"
          }
        }}
        disabled={!isRoleAnalyst({ role, preventTV: true, preventUser: noAccessPermission || isViewerPermission })}
        helperText={errorMessage}
        error={Boolean(errorMessage)}
        onChange={(e) => setInputValue(e.target.value)}
        value={inputValue}
        label="URL"
        variant="outlined"
      />
    </Stack>
  );
};
